import type { SVGProps } from "react";

export function SendIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0006 14L21.0006 3M10.0006 14L13.5006 21C13.5444 21.0957 13.6149 21.1769 13.7035 21.2338C13.7921 21.2906 13.8952 21.3209 14.0006 21.3209C14.1059 21.3209 14.209 21.2906 14.2976 21.2338C14.3862 21.1769 14.4567 21.0957 14.5006 21L21.0006 3M10.0006 14L3.00056 10.5C2.90482 10.4561 2.82369 10.3857 2.7668 10.2971C2.70992 10.2084 2.67969 10.1053 2.67969 10C2.67969 9.89468 2.70992 9.79158 2.7668 9.70295C2.82369 9.61431 2.90482 9.54387 3.00056 9.5L21.0006 3"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
